import { defineStore } from 'pinia';
import { ref } from 'vue';

import { crossbeamApi } from '@/api';
import { captureException } from '@/errors';
import { initStore } from '@/stores/store-utils';
import { MatchIssue, MatchIssueType, MatchIssues } from '@/types/match_issues';

export const useMatchIssuesStore = defineStore('MatchIssuesStore', () => {
  const matchIssueTypes = ref<MatchIssueType[]>([]);
  const issues = ref<MatchIssues>({});

  const { initError, ready, readySync, running, refresh } = initStore(
    async () => {
      const { data } = await crossbeamApi.GET('/v0.1/matching-issue-types');
      if (data?.items) matchIssueTypes.value = data.items;
    },
  );

  refresh({ useCache: true });

  async function fetchMatchIssuesBySourceIdAndRecordId({
    sourceId,
    recordId,
  }: {
    sourceId: number | string;
    recordId: string;
  }): Promise<void> {
    const { data, error } = await crossbeamApi.GET(
      '/v0.1/matching-issues/{source_id}/{master_id}',
      {
        params: { path: { source_id: Number(sourceId), master_id: recordId } },
      },
    );

    error
      ? captureException(error)
      : (issues.value[`${sourceId}_${recordId}`] = data.items);
  }

  function getMatchIssuesBySourceIdAndRecordId(
    sourceId: number,
    recordId: string,
  ): MatchIssue[] {
    return issues.value[`${sourceId}_${recordId}`] || [];
  }

  return {
    error: initError,
    ready,
    readySync,
    refreshMatchIssuesStore: refresh,
    running,
    issues,
    fetchMatchIssuesBySourceIdAndRecordId,
    getMatchIssuesBySourceIdAndRecordId,
    matchIssueTypes,
  };
});
